var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-card",
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _c("span", [_vm._v("店铺管理")])
          ]),
          _c(
            "el-row",
            { attrs: { gutter: 20, type: "flex", align: "middle" } },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "span",
                    { staticStyle: { "font-size": "14px", color: "#606266" } },
                    [_vm._v("会员编号：")]
                  ),
                  _c("el-input", {
                    staticStyle: { width: "60%" },
                    attrs: { placeholder: "请输入会员编号", clearable: "" },
                    nativeOn: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.onSearch($event)
                      }
                    },
                    model: {
                      value: _vm.searchNumber,
                      callback: function($$v) {
                        _vm.searchNumber = $$v
                      },
                      expression: "searchNumber"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "span",
                    { staticStyle: { "font-size": "14px", color: "#606266" } },
                    [_vm._v("执照名称：")]
                  ),
                  _c("el-input", {
                    staticStyle: { width: "60%" },
                    attrs: { placeholder: "请输入执照名称", clearable: "" },
                    nativeOn: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.onSearch($event)
                      }
                    },
                    model: {
                      value: _vm.searchLicenseName,
                      callback: function($$v) {
                        _vm.searchLicenseName = $$v
                      },
                      expression: "searchLicenseName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "span",
                    { staticStyle: { "font-size": "14px", color: "#606266" } },
                    [_vm._v("审核状态：")]
                  ),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "60%" },
                      attrs: { placeholder: "全部", clearable: "" },
                      on: { change: _vm.onSearch },
                      model: {
                        value: _vm.searchStatus,
                        callback: function($$v) {
                          _vm.searchStatus = $$v
                        },
                        expression: "searchStatus"
                      }
                    },
                    [
                      _c("el-option", { attrs: { label: "全部", value: "" } }),
                      _c("el-option", { attrs: { label: "待审核", value: 0 } }),
                      _c("el-option", { attrs: { label: "已通过", value: 1 } }),
                      _c("el-option", { attrs: { label: "已拒绝", value: -1 } })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "15px", "text-align": "right" } },
            [
              _c(
                "el-button",
                {
                  staticClass: "search-btn",
                  attrs: { type: "primary", icon: "el-icon-search" },
                  on: { click: _vm.onSearch }
                },
                [_vm._v("搜索")]
              ),
              _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-refresh" },
                  on: { click: _vm.onReset }
                },
                [_vm._v("重置")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-card",
        { staticStyle: { "margin-top": "20px" } },
        [
          _c(
            "div",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c("span", [_vm._v("店铺申请列表")]),
              _c(
                "el-tag",
                {
                  staticStyle: { "margin-left": "10px" },
                  attrs: { size: "small" }
                },
                [_vm._v("共 " + _vm._s(_vm.total) + " 条")]
              ),
              _c(
                "el-button",
                {
                  staticStyle: { float: "right" },
                  attrs: { type: "primary", icon: "el-icon-plus" },
                  on: { click: _vm.showAddDialog }
                },
                [_vm._v("添加店铺")]
              )
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.pagedData,
                border: "",
                "header-cell-style": {
                  backgroundColor: "#F5F7FA",
                  color: "#2C3E50"
                }
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  label: "序号",
                  width: "60",
                  align: "center"
                }
              }),
              _c("el-table-column", {
                attrs: { prop: "number", label: "会员编号", width: "100" }
              }),
              _c("el-table-column", {
                attrs: { prop: "shop_no", label: "店铺编号", width: "120" }
              }),
              _c("el-table-column", {
                attrs: { prop: "license_name", label: "执照名称", width: "150" }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "license_legal_person",
                  label: "法人姓名",
                  width: "100"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "license_credit_code",
                  label: "统一社会信用代码",
                  width: "160"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "license_img",
                  label: "营业执照",
                  width: "100",
                  align: "center"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.license_img
                          ? _c("el-image", {
                              staticStyle: {
                                width: "60px",
                                height: "40px",
                                "border-radius": "4px"
                              },
                              attrs: {
                                src: scope.row.license_img,
                                fit: "cover",
                                "preview-src-keys": [scope.row.license_img]
                              }
                            })
                          : _c("span", { staticStyle: { color: "#909399" } }, [
                              _vm._v("无")
                            ])
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "license_company_type",
                  label: "公司类型",
                  width: "100"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "license_business_address",
                  label: "注册地址",
                  "min-width": "200",
                  "show-overflow-tooltip": ""
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "status",
                  label: "审核状态",
                  width: "100",
                  align: "center"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.statusTagType(scope.row.status),
                              size: "small"
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.statusText(scope.row.status)) +
                                " "
                            )
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { prop: "add_time", label: "申请时间", width: "160" }
              }),
              _c("el-table-column", {
                attrs: { prop: "audit_time", label: "审核时间", width: "160" }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "remark",
                  label: "审核意见",
                  "min-width": "180",
                  "show-overflow-tooltip": ""
                }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  width: "250",
                  fixed: "right",
                  align: "center"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.status === 0
                          ? _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.showReviewDialog(scope.row)
                                  }
                                }
                              },
                              [_vm._v("审核")]
                            )
                          : _vm._e(),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "warning" },
                            on: {
                              click: function($event) {
                                return _vm.showEditDialog(scope.row)
                              }
                            }
                          },
                          [_vm._v("编辑")]
                        ),
                        scope.row.license_img
                          ? _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "info" },
                                on: {
                                  click: function($event) {
                                    return _vm.previewLicense(scope.row)
                                  }
                                }
                              },
                              [_vm._v("查看执照")]
                            )
                          : _vm._e()
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c("el-pagination", {
            staticStyle: { "margin-top": "20px", "text-align": "right" },
            attrs: {
              "current-page": _vm.currentPage,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.pageSize,
              total: _vm.total,
              layout: "total, sizes, prev, pager, next, jumper"
            },
            on: {
              "size-change": _vm.onSizeChange,
              "current-change": _vm.onPageChange
            }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "店铺申请审核",
            visible: _vm.reviewDialogVisible,
            width: "650px",
            "append-to-body": true,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.reviewDialogVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                "max-height": "60vh",
                "overflow-y": "auto",
                padding: "15px 30px"
              }
            },
            [
              _c(
                "el-descriptions",
                {
                  staticStyle: { "margin-bottom": "20px" },
                  attrs: { column: 2, border: "", size: "medium" }
                },
                [
                  _c("el-descriptions-item", { attrs: { label: "会员编号" } }, [
                    _vm._v(_vm._s(_vm.currentRow.number))
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "执照名称" } }, [
                    _vm._v(_vm._s(_vm.currentRow.license_name))
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "法人姓名" } }, [
                    _vm._v(_vm._s(_vm.currentRow.license_legal_person))
                  ]),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "统一社会信用代码" } },
                    [_vm._v(_vm._s(_vm.currentRow.license_credit_code))]
                  ),
                  _c("el-descriptions-item", { attrs: { label: "公司类型" } }, [
                    _vm._v(_vm._s(_vm.currentRow.license_company_type))
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "注册资金" } }, [
                    _vm._v(_vm._s(_vm.currentRow.license_registered_capital))
                  ]),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "执照有效期" } },
                    [_vm._v(_vm._s(_vm.currentRow.license_valid_period))]
                  ),
                  _c("el-descriptions-item", { attrs: { label: "申请时间" } }, [
                    _vm._v(_vm._s(_vm.currentRow.add_time))
                  ]),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "注册地址", span: 2 } },
                    [_vm._v(_vm._s(_vm.currentRow.license_business_address))]
                  )
                ],
                1
              ),
              _vm.currentRow.license_img
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        "margin-bottom": "20px",
                        "text-align": "center"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            color: "#606266",
                            "font-size": "13px",
                            "margin-bottom": "10px"
                          }
                        },
                        [_vm._v("营业执照图片")]
                      ),
                      _c("el-image", {
                        staticStyle: {
                          width: "320px",
                          height: "200px",
                          "border-radius": "8px",
                          border: "1px solid #EBEEF5"
                        },
                        attrs: {
                          src: _vm.currentRow.license_img,
                          fit: "contain",
                          "preview-src-keys": [_vm.currentRow.license_img]
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form",
                {
                  ref: "reviewForm",
                  attrs: {
                    model: _vm.reviewForm,
                    rules: _vm.reviewRules,
                    "label-width": "100px"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "审核结果", prop: "status" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.reviewForm.status,
                            callback: function($$v) {
                              _vm.$set(_vm.reviewForm, "status", $$v)
                            },
                            expression: "reviewForm.status"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("通过")
                          ]),
                          _c("el-radio", { attrs: { label: -1 } }, [
                            _vm._v("拒绝")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "审核意见", prop: "remark" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 3,
                          placeholder: "请输入审核意见"
                        },
                        model: {
                          value: _vm.reviewForm.remark,
                          callback: function($$v) {
                            _vm.$set(_vm.reviewForm, "remark", $$v)
                          },
                          expression: "reviewForm.remark"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.reviewDialogVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reviewLoading },
                  on: { click: _vm.onReviewSubmit }
                },
                [_vm._v("确 认")]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "店铺专属编号",
            visible: _vm.numberDialogVisible,
            width: "400px",
            "append-to-body": true,
            "close-on-click-modal": true
          },
          on: {
            "update:visible": function($event) {
              _vm.numberDialogVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { "text-align": "center", padding: "30px 20px" } },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    color: "#606266",
                    "font-size": "14px",
                    "margin-bottom": "15px"
                  }
                },
                [_vm._v("该店铺的专属编号为")]
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    "font-size": "28px",
                    "font-weight": "700",
                    color: "#FF6B35",
                    "letter-spacing": "2px",
                    padding: "20px",
                    background: "rgba(255, 107, 53, 0.08)",
                    "border-radius": "12px",
                    border: "1px solid rgba(255,107,53,0.2)"
                  }
                },
                [_vm._v(" " + _vm._s(_vm.currentRow.shop_no) + " ")]
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    color: "#909399",
                    "font-size": "13px",
                    "margin-top": "15px"
                  }
                },
                [
                  _vm._v(
                    " 执照名称：" + _vm._s(_vm.currentRow.license_name) + " "
                  )
                ]
              ),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-top": "20px" },
                  attrs: { size: "small" },
                  on: {
                    click: function($event) {
                      return _vm.copyStoreNumber(_vm.currentRow.shop_no)
                    }
                  }
                },
                [_vm._v(" 复制编号 ")]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.editForm.id ? "编辑店铺信息" : "添加店铺",
            visible: _vm.editDialogVisible,
            width: "650px",
            "append-to-body": true,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.editDialogVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                "max-height": "60vh",
                "overflow-y": "auto",
                padding: "15px 30px"
              }
            },
            [
              _c(
                "el-form",
                {
                  ref: "editForm",
                  attrs: {
                    model: _vm.editForm,
                    rules: _vm.editRules,
                    "label-width": "120px"
                  }
                },
                [
                  !_vm.editForm.id
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "会员编号", prop: "number" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入会员编号" },
                            model: {
                              value: _vm.editForm.number,
                              callback: function($$v) {
                                _vm.$set(_vm.editForm, "number", $$v)
                              },
                              expression: "editForm.number"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: "执照名称", prop: "license_name" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入执照名称" },
                        model: {
                          value: _vm.editForm.license_name,
                          callback: function($$v) {
                            _vm.$set(_vm.editForm, "license_name", $$v)
                          },
                          expression: "editForm.license_name"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "法人姓名", prop: "license_legal_person" }
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入法人姓名" },
                        model: {
                          value: _vm.editForm.license_legal_person,
                          callback: function($$v) {
                            _vm.$set(_vm.editForm, "license_legal_person", $$v)
                          },
                          expression: "editForm.license_legal_person"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "统一社会信用代码",
                        prop: "license_credit_code"
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入统一社会信用代码" },
                        model: {
                          value: _vm.editForm.license_credit_code,
                          callback: function($$v) {
                            _vm.$set(_vm.editForm, "license_credit_code", $$v)
                          },
                          expression: "editForm.license_credit_code"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "公司类型", prop: "license_company_type" }
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入公司类型" },
                        model: {
                          value: _vm.editForm.license_company_type,
                          callback: function($$v) {
                            _vm.$set(_vm.editForm, "license_company_type", $$v)
                          },
                          expression: "editForm.license_company_type"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "注册资金",
                        prop: "license_registered_capital"
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入注册资金" },
                        model: {
                          value: _vm.editForm.license_registered_capital,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.editForm,
                              "license_registered_capital",
                              $$v
                            )
                          },
                          expression: "editForm.license_registered_capital"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "执照有效期",
                        prop: "license_valid_period"
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入执照有效期" },
                        model: {
                          value: _vm.editForm.license_valid_period,
                          callback: function($$v) {
                            _vm.$set(_vm.editForm, "license_valid_period", $$v)
                          },
                          expression: "editForm.license_valid_period"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "注册地址",
                        prop: "license_business_address"
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 2,
                          placeholder: "请输入注册地址"
                        },
                        model: {
                          value: _vm.editForm.license_business_address,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.editForm,
                              "license_business_address",
                              $$v
                            )
                          },
                          expression: "editForm.license_business_address"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "营业执照", prop: "license_img" } },
                    [
                      _c(
                        "el-upload",
                        {
                          attrs: {
                            action: "",
                            "http-request": _vm.onUploadLicense,
                            "show-file-list": false,
                            accept: "image/*",
                            "before-upload": _vm.onBeforeLicenseUpload,
                            "on-success": _vm.onLicenseUploadSuccess
                          }
                        },
                        [
                          _vm.editForm.license_img
                            ? _c(
                                "div",
                                { staticClass: "license-upload-preview" },
                                [
                                  _c("el-image", {
                                    staticStyle: {
                                      width: "100%",
                                      height: "100%",
                                      "border-radius": "6px"
                                    },
                                    attrs: {
                                      src: _vm.editForm.license_img,
                                      fit: "contain"
                                    }
                                  })
                                ],
                                1
                              )
                            : _c(
                                "div",
                                { staticClass: "license-upload-placeholder" },
                                [
                                  _c("i", { staticClass: "el-icon-plus" }),
                                  _c("span", [_vm._v("上传营业执照")])
                                ]
                              )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.editDialogVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.editLoading },
                  on: { click: _vm.onEditSubmit }
                },
                [_vm._v("确 认")]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "营业执照",
            visible: _vm.licenseDialogVisible,
            width: "700px",
            "append-to-body": true,
            "close-on-click-modal": true
          },
          on: {
            "update:visible": function($event) {
              _vm.licenseDialogVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { "text-align": "center", padding: "20px" } },
            [
              _c("el-image", {
                staticStyle: {
                  "max-width": "100%",
                  "max-height": "60vh",
                  "border-radius": "8px"
                },
                attrs: { src: _vm.licensePreviewUrl, fit: "contain" }
              })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }